import { ScormCard } from "components/cards/ScormCard/ScormCard";
import { type ScormCardBaseProps } from "components/cards/ScormCard/types";
import React from "react";
import { ThreeDotsItemMenu } from "./ThreeDotsItemMenu";
import type { ScormOverview } from "../../types/models";

export interface OverviewCardProps extends ScormCardBaseProps<ScormOverview> {
  handleEdit: (id: number, isDraft: boolean) => void;
  handleDelete: (ids: number[], flowsCount?: number, packsCount?: number) => void;
  handlePublish: (id: number, flowsCount: number, hasBeenPublished: boolean) => void;
  handleToggleVisibility: (id: number[], hidden: boolean) => () => void;
  readonly?: boolean;
  hideDisabled?: boolean;
}

export const OverviewCard = (props: OverviewCardProps): React.ReactElement => {
  const { item, selected, onSelect, readonly, disabled, hideDisabled, ...popupMenuProps } = props;
  return (
    <ScormCard
      item={item}
      disabled={disabled}
      url={props.item.id.toString()}
      onSelect={onSelect}
      popupMenu={
        <ThreeDotsItemMenu
          {...popupMenuProps}
          circle
          item={item}
          outlinedEllipsis
          readonly={readonly}
          isChecked={selected}
          hideDisabled={hideDisabled}
        />
      }
      selected={selected}
    />
  );
};
